/**
 * Combien de choix le répondant peut désigner : un seul, ou autant qu'il en reconnaît.
 *
 * Les valeurs sont celles du discriminant renvoyé par l'API. Le nombre attendu change la marque que
 * porte chaque choix — un rond pour n'en prendre qu'un, une case à cocher pour en prendre plusieurs.
 */
export enum CHOICES_ANSWER_TYPE {
    UNIQUE = 'UNIQUE',
    MULTIPLE = 'MULTIPLE',
}
